import type { IsoDate, ProgressState, VacationAllowance } from '../models/types';

/**
 * Gün güvencesi — bir günün "dondurulmuş" olup olmadığı.
 *
 * CLAUDE.md §7.6 ve §7.7'ye göre bir gün iki yoldan dondurulabilir:
 * - **Tatil hakkı** kullanılarak (§7.7)
 * - **Ödülle satın alınarak** (§7.6)
 *
 * İkisi de aynı etkiyi yapar: o gün ceza işlemez ve gün Day Streak'e
 * sayılır. Farkları yalnızca kaynaktır (hak havuzu mu, 100 puan mı).
 *
 * **KESİNLEŞTİ — İkisi aynı gün birlikte KULLANILAMAZ.** Gün zaten
 * güvenceye alınmışsa ikincisini harcamak, kullanıcının hakkını ya da
 * puanını hiçbir karşılık almadan yakardı.
 *
 * Bu dosya saf fonksiyonlardan oluşur: veritabanına dokunmaz, veriyi
 * çağıran taraf getirir. Böylece hem ekranlar hem gün kapanışı aynı
 * kuralı tek bir yerden okur.
 */

/** Bir günün neyle dondurulduğu. */
export type DayCover = 'none' | 'vacation' | 'reward';

/**
 * Belirli bir günün güvence durumunu söyler.
 *
 * Tatil önce kontrol edilir; ikisi birden olamaz ama bozuk bir veri
 * durumunda tek bir cevap dönmek zorundayız.
 */
export function getDayCover(
  date: IsoDate,
  allowance: VacationAllowance | undefined,
  progress: ProgressState,
): DayCover {
  if (allowance?.usedDates.includes(date)) return 'vacation';
  if (progress.rewardDates.includes(date)) return 'reward';
  return 'none';
}

/** Gün tatil ya da ödülle dondurulmuş mu? */
export function isDayFrozen(
  date: IsoDate,
  allowance: VacationAllowance | undefined,
  progress: ProgressState,
): boolean {
  return getDayCover(date, allowance, progress) !== 'none';
}

/**
 * Güvence durumunu kullanıcıya gösterilecek metne çevirir.
 * `none` için metin yoktur — o durumda düğmeler zaten açıktır.
 */
export function describeDayCover(cover: DayCover): string | null {
  if (cover === 'vacation') return 'Bugün tatil günü olarak işaretli.';
  if (cover === 'reward') return 'Bugün ödülle satın alındı.';
  return null;
}
